import anchorme from 'anchorme'

const VueAnchorme = {
    install (Vue) {
        Vue.prototype.$anchorme = anchorme
    }
}

export default VueAnchorme
